import {makeObservable} from 'mobx';

import type {GoalApiModel} from '../../../api/goal';
import type {Nullable} from '../../../utils/utility-types';
import type {CourseModel} from '../Course/Course.model';
import type {DateTimeModel} from '../Date/DateTime.model';
import type {ProgramModel} from '../Program/Program.model';
import type {SubgoalModel} from '../Subgoal/Subgoal.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'GoalModel';

export class GoalModel extends BaseModel {
  clientAttitude: Nullable<number>;
  clientComment: string;
  clientId: Nullable<string>;
  coachAttitude: Nullable<number>;
  coachComment: string;
  coachIds: string[];
  color: Nullable<string>;
  counters: {
    childGoals: number;
    clientsNeedReview: number;
    clientsReached: number;
    clientSubgoals: number;
  };
  course: Nullable<CourseModel>;
  courseId: Nullable<string>;
  created: DateTimeModel;
  description: string;
  icon: Nullable<string>;
  isClientManaged: boolean;
  lastActivity: Nullable<DateTimeModel>;
  notified: {
    expiringReview: Nullable<DateTimeModel>;
    reviewReminder: Nullable<DateTimeModel>;
  };
  parentGoalId: Nullable<string>;
  program: Nullable<ProgramModel>;
  programId: string;
  progress: number;
  reached: Nullable<DateTimeModel>;
  reviewUntil: Nullable<DateTimeModel>;
  sortOrder: number;
  status: GoalModel.Status;
  subgoalIds: string[];
  subgoals: SubgoalModel[] = [];
  title: string;
  updated: DateTimeModel;
  userId: string;

  constructor(props: GoalModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<GoalModel, GoalModel.Props>(props),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace GoalModel {
  export type Props = BaseModel.ModelToProps<GoalModel, 'clone'>;

  export type Status = GoalApiModel['status'];
}
